import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Globe } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/tools/website-checker')({
    staticData: {
        breadcrumb: {
            title: 'Website checker',
        },
        featureFlag: 'compliance-website-checker',
        // Declared on the layout so the report pages carry the module gate too.
        modules: ['website-checker'],
        permissions: ['website_checker:access'],
        ui: {
            icon: Globe,
        },
    },
    component: Outlet,
});
